import cloneDeep from 'lodash/cloneDeep';

import type { LogicPageQuestion } from './logic';

export interface Page {
    id: number;
    name: string;
    fresh: boolean; // just added
    expand: boolean;
    onebyone: boolean;
    random: boolean;
    randomFixed: boolean;
    randomCount: number;
    questionCount: number;
    questions: Array<LogicPageQuestion>;
    order: number;
}

export const initialPage: Readonly<Page> = {
    id: 0,
    name: '',
    fresh: false,
    expand: false,
    onebyone: false,
    random: false,
    randomFixed: false,
    randomCount: null,
    questionCount: 0,
    questions: [],
    order: 0,
};

export const mapPage = ({
    ID,
    QUESTION_COUNT,
    QUESTION_RANDOM_ORDERING,
    QUESTION_SP,
    TITLE,
    TOTAL_QUESTION,
    ORDER,
    PAGE_RANDOM_ORDERING_FIXED,
}: {
    ID: number;
    TITLE: string;
    TOTAL_QUESTION: number;
    QUESTION_COUNT: number | null;
    QUESTION_RANDOM_ORDERING: number;
    QUESTION_SP: number;
    ORDER: number;
    PAGE_RANDOM_ORDERING_FIXED: number;
}): Page => ({
    ...cloneDeep(initialPage),
    id: ID,
    name: TITLE,
    random: Boolean(QUESTION_RANDOM_ORDERING),
    randomFixed: Boolean(PAGE_RANDOM_ORDERING_FIXED),
    randomCount: QUESTION_COUNT || 0,
    questionCount: TOTAL_QUESTION,
    expand: true,
    onebyone: Boolean(QUESTION_SP),
    questions: [],
    order: ORDER,
});
